export default __webpack_public_path__ + "static/media/feedBack.1ff72fd1.svg";